/* Board columns — every module that will get change requests. Only Orders has data today. */
export const CHANGE_REQUEST_COLUMNS = [
  { key: "PRODUCT", label: "Products", tone: "products", refLabel: "Product ID" },
  { key: "ORDER", label: "Orders", tone: "orders", refLabel: "Order ID" },
  { key: "CUSTOMER", label: "Customers", tone: "customers", refLabel: "Customer Name" },
  { key: "VENDOR", label: "Vendors", tone: "vendors", refLabel: "Vendor Name" },
  { key: "CONTRACT_VEHICLE", label: "Contract Vehicles", tone: "contracts", refLabel: "Contract Vehicle" },
];

export const STATUS_FILTERS = [
  { key: "ALL", label: "All Status" },
  { key: "PENDING", label: "Pending" },
  { key: "APPROVED", label: "Approved" },
  { key: "REJECTED", label: "Rejected" },
  { key: "CANCELLED", label: "Cancelled" },
];

export const SCOPE_FILTERS = [
  { key: "all", label: "Everything I can see" },
  { key: "awaiting_me", label: "Waiting on me" },
  { key: "mine", label: "My requests" },
];

export const REQUEST_STATUS_META = {
  PENDING: { label: "Pending", className: "cr-status-pending" },
  APPROVED: { label: "Approved", className: "cr-status-approved" },
  REJECTED: { label: "Rejected", className: "cr-status-rejected" },
  CANCELLED: { label: "Cancelled", className: "cr-status-cancelled" },
};

/* Order sections, mirroring backend constants/changeLog/orderFields.js. */
export const ORDER_SECTION_LABELS = {
  general: "General",
  billing_shipping: "Billing & Shipping",
  products_sales: "Products (Sales)",
  products_purchasing: "Products (Purchasing)",
  payment_cards: "Payment Cards",
  packing_slips: "Packing Slips",
  attachments: "Attachments",
  notes: "Notes",
  other: "Other",
  status: "Status Change",
};

/* Product sections, mirroring backend constants/changeLog/productFields.js. */
export const PRODUCT_SECTION_LABELS = {
  status: "Status Change",
  general: "Product",
  variants: "Variants",
  kit_products: "Kit Products",
  contract_vehicles: "Contract Vehicles",
  attachments: "Attachments",
  notes: "Notes",
};

/** Section name for a card, in the module it belongs to. */
export const sectionLabel = (request, section) =>
  (request?.module_type === "PRODUCT" ? PRODUCT_SECTION_LABELS : ORDER_SECTION_LABELS)[section] || section;

export const moduleRefLabel = (request) => {
  if (request.module_type === "ORDER") {
    return `Order ${request.module_ref}`;
  }
  return request.module_type === "PRODUCT"
    ? `Product ${request.module_ref}`
    : request.module_ref;
};

/** "Order ID", "Product ID" … — what the reference on a card is called. */
export const refLabel = (request) =>
  CHANGE_REQUEST_COLUMNS.find((column) => column.key === request.module_type)?.refLabel || "Reference";

/** Department of the requester, title-cased for the filter and the card. */
export const departmentLabel = (value) =>
  (value || "")
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
